<template>
  <button-full
    :disabled="isProductDisabled"
    data-testid="addToCart"
    @click.native="addToCart(product)"
  >
    {{ $t('Add to cart') }}
  </button-full>
</template>

<script>
import { formatProductMessages } from '@vue-storefront/core/filters/product-messages'
import { notifications } from '@vue-storefront/core/modules/cart/helpers'
import focusClean from 'theme/components/theme/directives/focusClean'
import ButtonFull from 'theme/components/theme/ButtonFull.vue'
import { mapGetters } from 'vuex'
import ScrollLock from 'theme/mixins/scrollLock'

export default {
  directives: { focusClean },
  components: { ButtonFull },
  mixins: [ScrollLock],
  props: {
    product: {
      required: true,
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      isAddingToCart: 'cart/getIsAdding'
    }),
    isProductDisabled () {
      return this.disabled || formatProductMessages(this.product.errors) !== '' || this.isAddingToCart
    }
  },
  beforeMount () {
    this.$bus.$on('product-after-removevariant', this.onAfterRemovedVariant)
  },
  beforeDestroy () {
    this.$bus.$off('product-after-removevariant')
  },
  methods: {
    onAfterRemovedVariant () {
      this.$forceUpdate()
    },
    async addToCart (product) {
      try {
        await this.$store.dispatch('cart/addItem', { productToAdd: product })
        this.$bus.$emit('modal-show', 'modal-addToCart')
        this.disableBodyScroll()
      } catch (message) {
        this.notifyUser(notifications.createNotification({ type: 'error', message }))
        this.clearAllBodyScrollLocks()
      }
    },
    notifyUser (notificationData) {
      this.$store.dispatch('notification/spawnNotification', notificationData, { root: true })
    }
  }
}
</script>
